<template>
  <option v-for="option in options" :key="option.value" :value="option.value">
    {{ option.text }}
  </option>
</template>

<script setup lang="ts">
import type { FormSelectOption } from "./types";

type FormInputProps = {
  options: FormSelectOption[];
};

defineProps<FormInputProps>();
</script>
